(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ClinicNameDeleteController',ClinicNameDeleteController);

    ClinicNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClinicName'];

    function ClinicNameDeleteController($uibModalInstance, entity, ClinicName) {
        var vm = this;
        vm.clinicName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ClinicName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
